import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  withAuthGatewayDiscovery,
  withBackstageAuth,
  withJsonContentType,
} from '@mercedes-benz/http-common';
import { TechInsightsClient } from '@mercedes-benz/tech-insights-client';
import { techInsightsApiRef } from '@mercedes-benz/tech-insights-react';

import { rootRouteRef } from './routes';

export const techInsightsPlugin = createPlugin({
  id: 'tech-insights',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: techInsightsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        TechInsightsClient.create({
          // The discovery interceptor rewrites `baseURL` per request to
          // `${discoveryApi.getBaseUrl('auth-gateway')}/tech-insights`, so the
          // value here is only a suffix. The 5 sub-SDKs append their own paths
          // ("/contracts", "/workflows", "/lake", "/providers", "/tech-stack")
          // to this, which axios then resolves relative to the resolved base.
          apiBaseUrl: '',
          axiosPlugin: instance => {
            withAuthGatewayDiscovery(discoveryApi, 'tech-insights')(instance);
            withBackstageAuth(identityApi)(instance);
            withJsonContentType()(instance);
            return instance;
          },
        }),
    }),
  ],
});

export const TechInsightsQuickView = techInsightsPlugin.provide(
  createRoutableExtension({
    name: 'TechInsightsQuickView',
    component: () =>
      import('./components/TechInsightsQuickView/TechInsightsQuickView').then(
        m => m.TechInsightsQuickView,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const TechInsightsPage = techInsightsPlugin.provide(
  createRoutableExtension({
    name: 'TechInsightsPage',
    component: () =>
      import('./components/TechInsightsPage/TechInsightsPage').then(
        m => m.TechInsightsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
